<template>
  <home endpoint="apikey" :params="params"></home>
</template>

<script>
import home from '@/components/tools/Index'
export default {
name: 'apikey',
components: {
  home,
},
data () {
  return {
    params: {
      primaryKey: 'id',
      fields: [
        {name: 'id', label: 'ID', readonly: true},
        {name: 'Key', label: 'Key'},
        {name: 'Type', label: 'Tipo', editor: 'select', options: [
          {value: 'OFFICE_GRAPH', label: 'Office Graph'},
        ]},
      ],
      title: 'API Key',
      title2: 'API Key'
    }
  }
},
}
</script>
